import React from 'react';

import { Paper } from '@material-ui/core';
import Popper from '@material-ui/core/Popper';
import styled from 'styled-components';
import { StyledButton } from 'styles/common';

import { SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';
import { sendAddedActionItemOwner } from 'constants/mixpanelHelper';

import { makeToEmployeesSearchCompatible } from 'services/helpers/employee';
import { searchAutoComplete } from 'services/search';

import SearchComponent, { MultiEmployeePhotoLabel, MultiValueRemove, PhotoLabelOptionTiny } from './SearchComponent';
import usePopupState from './hooks/usePopupState';
import SimplePopup from './popup/SimplePopup';

// we need to use important here because in searchComponent
// we are using styled components and they have more priority
// we shouldn't be using styled components there, in case of react-select
// we should only be using the styles system provided by them
export const employeeSearchStyles = {
  control: (styles) => ({
    ...styles,
    border: '1px solid #eee !important',
    padding: '0px !important',
    borderRadius: '4px !important',
    minHeight: '0px !important',
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingTop: '0px !important',
  }),
  container: (styles) => ({
    width: '100% !important',
    minWidth: '40px',
    // maxWidth: '90% !important',
    marginTop: '2px',
  }),
};

export default function EditOwners({
  teamId,
  employees,
  updateEmployees,
  removeEmployee,
  renderSave,
  rightJustified = false,
  filterEmpIds = null,
  reactSelectComponentsOverride = {},
}) {
  const onOwnersChange = (employees, { action, removedValue: removedEmployee }) => {
    if (removedEmployee) removeEmployee(removedEmployee, employees);
    else {
      updateEmployees(employees);
      sendAddedActionItemOwner();
    }
  };
  const loadOptions = (value, callback) =>
    searchAutoComplete({
      tagType: 'EMPLOYEE_NAME_AND_EMAIL',
      query: value,
      callback,
      widgetType: SEARCH_WIDGET_TYPES.task,
      teamId,
      limit: 15,
    });

  return (
    // <div style={{ position: 'relative' }}>
    // </div>
    <SearchComponent
      value={makeToEmployeesSearchCompatible(employees)}
      onChange={onOwnersChange}
      loadOptions={loadOptions}
      components={{
        Option: PhotoLabelOptionTiny,
        MultiValueLabel: MultiEmployeePhotoLabel,
        MultiValueRemove,
        ...reactSelectComponentsOverride,
      }}
      rightJustified={rightJustified}
      isMulti
      styles={employeeSearchStyles}
      filterEmpIds={filterEmpIds}
      defaultOptions={false}
    />
  );
}

function EditOwnerPopupContent({ renderEditOwner, onSave, onCancel }) {
  return (
    <Paper>
      {renderEditOwner && renderEditOwner()}
      <div>
        <StyledButton color="primary" onClick={onSave}>
          Save
        </StyledButton>
        <StyledButton onClick={onCancel}>Cancel</StyledButton>
      </div>
    </Paper>
  );
}

/*
 This is required separately because EditOwnerSimplePopup causes positioning issues inside 
 cardview
*/
export function EditOwnerPopup({ id, anchorEl, renderEditOwner, onSave, onCancel }) {
  const { open, newId } = usePopupState({ id, anchorEl });
  return (
    <StyledPopper
      id={newId}
      open={open}
      anchorEl={anchorEl}
      placement="bottom-end"
      modifiers={{
        flip: {
          enabled: true,
        },
      }}
    >
      <EditOwnerPopupContent renderEditOwner={renderEditOwner} onSave={onSave} onCancel={onCancel} />
    </StyledPopper>
  );
}

/* 
  This separate simple popup was created because react select inside 
  the above popup inside task panel was causing problems, dropdown wasn't opening
*/
export function EditOwnerSimplePopup({ id, anchorEl, renderEditOwner, onSave, onCancel, className }) {
  return (
    <SimplePopup className={className} menuId={id} anchorEl={anchorEl}>
      <EditOwnerPopupContent renderEditOwner={renderEditOwner} onSave={onSave} onCancel={onCancel} />
    </SimplePopup>
  );
}

const StyledPopper = styled(Popper)`
  min-width: 150px;
  max-width: 200px;
`;
